import { render, staticRenderFns } from "./ItemsListTable.vue?vue&type=template&id=e273ee00&scoped=true"
import script from "./ItemsListTable.vue?vue&type=script&lang=ts"
export * from "./ItemsListTable.vue?vue&type=script&lang=ts"
import style0 from "./ItemsListTable.vue?vue&type=style&index=0&id=e273ee00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e273ee00",
  null
  
)

export default component.exports